import React from 'react';
import PropTypes from 'prop-types';
import convertTcmLink from '../../utils/convertTcmLink';

const UnorderedList = ({ list }) => (
  <ul>
    {list.map((listItem, listItemindex) => (
      <li key={listItemindex}>{convertTcmLink(listItem.text)}</li>
    ))}
  </ul>
);

UnorderedList.propTypes = {
  list: PropTypes.array,
};

export default UnorderedList;



// WEBPACK FOOTER //
// ./library/app/components/Content/UnorderedList.js